interface UseObserveElementOptions {
  onObserve: ({ visible }: { visible: boolean }) => void;
}

export function useObserveElement(options: UseObserveElementOptions) {
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        options.onObserve({ visible: entry.isIntersecting });
      });
    },
    {
      threshold: [0, 1],
      rootMargin: '-125px 0px -125px 0px',
    }
  );

  const observe = (element: HTMLElement) => {
    observer.observe(element);
  };

  const disconnect = () => {
    observer.disconnect();
  };

  return { observe, disconnect };
}
